
import { defineComponent, onMounted, getCurrentInstance, reactive } from 'vue'
import { useStore } from 'vuex'
import { setDocumentTitle } from '@/utils/dom'
import { PaySussessTexMap } from '@/defination/malfunction-repair'
import { getServiceChargePayDetail } from '@/apis/malfunction-repair'
import { Toast } from 'vant'

export default defineComponent({
  setup() {
    const store = useStore()
    const { proxy } = getCurrentInstance()
    const payMessage = reactive({
      type: '',
      orderNum: '',
      amount: '',
      orderName: '',
    })
    const handleComplete = () => {
      let query: any = {}
      if (proxy.$route.query.from) {
        query['from'] = proxy.$route.query.from
      }
      proxy.$router.replace({
        name: 'malfunction-repair-service-order-detail',
        query: {
          guid: proxy.$route.params.guid,
        },
      })
    }
    onMounted(async () => {
      console.log('dddd')
      const title = PaySussessTexMap.get(proxy.$route.params.orderName as string)
      payMessage.orderNum = proxy.$route.params.sn as string
      payMessage.orderName = PaySussessTexMap.get(proxy.$route.params.orderName as string)
      if (proxy.$route.params.orderName === 'serviceCharge') {
        // 刷新价格
        try {
          Toast.loading({
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
          })

          let data = await getServiceChargePayDetail(proxy.$route.params.orderGuid as string)
          payMessage.amount = data.pay_amount
          Toast.clear()
        } catch (e) {
          Toast.clear()
        }
      } else {
        payMessage.amount = Number(proxy.$route.params.amount).toFixed(2)
      }
      if (store.getters.isMiniProgram) {
        setDocumentTitle(title || '')
      }
    })
    return {
      payMessage,
      handleComplete,
    }
  },
})
